import { render, staticRenderFns } from "./meas.vue?vue&type=template&id=55ffbb47&scoped=true"
import script from "./meas.vue?vue&type=script&lang=js"
export * from "./meas.vue?vue&type=script&lang=js"
import style0 from "./meas.vue?vue&type=style&index=0&id=55ffbb47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ffbb47",
  null
  
)

export default component.exports